export default __webpack_public_path__ + "static/media/bt_icon.d314cfff.svg";